(function () {
  'use strict';
  var config = document.getElementById('sv-french-editorial-strings');
  if (!config) return;
  var copy = JSON.parse(config.textContent);
  var productRequests = new Map();
  var localizedProducts = new Map();
  function productHandle(link) {
    if (!link) return '';
    try {
      var url = new URL(link.getAttribute('href'), location.origin);
      var match = url.pathname.match(/\/products\/([^/]+)\/?$/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (_) { return ''; }
  }
  function localizedProduct(handle) {
    if (!productRequests.has(handle)) {
      var url = new URL(window.Shopify.routes.root + 'search', location.origin);
      url.searchParams.set('view', 'sv-product-localization');
      url.searchParams.set('q', handle);
      productRequests.set(handle, fetch(url.pathname + url.search, {credentials:'same-origin'})
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; }));
    }
    return productRequests.get(handle);
  }
  function applyProduct(widget, row, id, originalHandle, product) {
    var input = row.querySelector('input[name="product_' + id + '"]');
    if (!input || !row.isConnected || !product || String(product.id) !== id || typeof product.title !== 'string' || typeof product.url !== 'string') return;
    var target;
    try {
      target = new URL(product.url, location.origin);
      if (target.origin !== location.origin || !/\/products\//.test(target.pathname)) return;
    } catch (_) { return; }
    var title = typeof window.svStripProductTitleTags === 'function' ? window.svStripProductTitleTags(product.title).trim() : product.title.trim();
    if (!title) return;
    localizedProducts.set(id, product);
    row.querySelectorAll('.translatable, .cbb-frequently-bought-selector-link').forEach(function (label) {
      if (label.textContent !== title) label.textContent = title;
    });
    var selection = copy.selection.replace('{product}', title);
    if (input.getAttribute('aria-label') !== selection) input.setAttribute('aria-label', selection);
    var targetHandle = decodeURIComponent(target.pathname.split('/').filter(Boolean).pop());
    widget.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      var handle = productHandle(link);
      if (handle !== originalHandle && handle !== targetHandle) return;
      var original = new URL(link.getAttribute('href'), location.origin);
      var href = target.pathname + original.search + original.hash;
      if (link.getAttribute('href') !== href) link.setAttribute('href', href);
      if (link.hasAttribute('aria-label') && link.getAttribute('aria-label') !== title) link.setAttribute('aria-label', title);
      link.querySelectorAll('[role="img"], img').forEach(function (image) {
        var attribute = image.tagName === 'IMG' ? 'alt' : 'aria-label';
        if (image.getAttribute(attribute) !== title) image.setAttribute(attribute, title);
      });
    });
  }
  function localizeRoutineProducts() {
    document.querySelectorAll('.cbb-frequently-bought-container').forEach(function (widget) {
      widget.querySelectorAll('.cbb-frequently-bought-selector-list li').forEach(function (row) {
        var input = row.querySelector('input[name^="product_"]');
        var match = input && input.name.match(/^product_(\d+)$/);
        if (!match) return;
        var id = match[1];
        var link = row.querySelector('a.cbb-frequently-bought-selector-link');
        var handle = productHandle(link);
        var current = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
        var heading = document.querySelector('h1.page-heading');
        if (!handle && current && String(current.id) === id && heading) {
          applyProduct(widget, row, id, '', {id:id,title:heading.textContent.trim(),url:location.pathname});
        } else if (localizedProducts.has(id)) {
          applyProduct(widget, row, id, handle, localizedProducts.get(id));
        } else if (handle) {
          localizedProduct(handle).then(function (product) { applyProduct(widget, row, id, handle, product); });
        }
      });
    });
  }
  function localizePrices() {
    var selector = '.money, .price, .price-sale, .price-compare, .sticky-price, ' +
      '.cart-item-price, .cart-item-total-price, .item-price, .item-total, ' +
      '.hulkapps-cart-original-total, .docapp-right, .sv-cart-sticky-total';
    document.querySelectorAll(selector).forEach(function (element) {
      var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (node.parentElement.closest('script, style, textarea, [contenteditable="true"]')) continue;
        var value = node.nodeValue.replace(/(?<![A-Za-z])\$\s*(\d+(?:,\d{3})*(?:\.\d{2})?)(?![\d.,])/g, function (_, amount) {
          var decimals = amount.indexOf('.') >= 0 ? 2 : 0;
          return new Intl.NumberFormat('fr-CA', {
            minimumFractionDigits: decimals, maximumFractionDigits: decimals
          }).format(Number(amount.replace(/,/g, ''))) + '\u00a0$';
        });
        if (value !== node.nodeValue) node.nodeValue = value;
      }
    });
  }
  function update() {
    localizePrices();
    localizeRoutineProducts();
    document.querySelectorAll('#cartform th.total-price').forEach(function (cell) {
      if (cell.textContent.trim() !== copy.cart_total) cell.textContent = copy.cart_total;
    });
    document.querySelectorAll('textarea[name="note"]').forEach(function (field) {
      if (field.getAttribute('aria-label') !== copy.cart_note) field.setAttribute('aria-label', copy.cart_note);
    });
    document.querySelectorAll('.cbb-frequently-bought-container select').forEach(function (select) {
      if (select.getAttribute('aria-label') === 'Variant selector') select.setAttribute('aria-label', copy.variant_selector);
      Array.from(select.options).forEach(function (option) {
        var value = option.textContent.replace(/\bFull[- ]Size\b/gi, copy.full_size)
          .replace(/\bTravel[- ]Size\b/gi, copy.travel_size)
          .replace(/\bpads\b/gi, copy.pads)
          .replace(/\s+TSA Approved\b/gi, '; ' + copy.tsa_approved)
          .replace(/(\d)\.(\d)(?=\d*\s*(?:g|mL)\b)/g, '$1,$2');
        if (value !== option.textContent) option.textContent = value;
      });
    });
    document.querySelectorAll('.cbb-frequently-bought-container input[aria-label]').forEach(function (field) {
      var label = field.getAttribute('aria-label');
      if (/^Selection of /i.test(label)) field.setAttribute('aria-label', copy.selection.replace('{product}', label.replace(/^Selection of /i, '')));
    });
    document.querySelectorAll('.tmenu_skip-link').forEach(function (link) {
      if (link.textContent.trim() === 'Skip to main content') link.textContent = copy.skip;
    });
    document.querySelectorAll('.aph_bar_message_body').forEach(function (message) {
      var walker = document.createTreeWalker(message, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var value = node.nodeValue.replace(/(\d+(?:[.,]\d+)?)\s*%\s*Off\s+Thanksgiving\s+Sale!/gi, function (_, percent) {
          return copy.sale.replace('{percent}', percent);
        }).replace(/(\d+(?:[.,]\d+)?)\s*%\s*Off\s+Fall\s+Sale!/gi, function (_, percent) {
          return copy.fall_sale.replace('{percent}', percent.replace('.', ','));
        }).replace(/(\d+(?:[.,]\d+)?)\s*%\s*Off\s+Halloween\s+Sale!?/gi, function (_, percent) {
          return copy.halloween_sale.replace('{percent}', percent.replace('.', ','));
        });
        if (value !== node.nodeValue) node.nodeValue = value;
      }
    });
    document.querySelectorAll('.aph_bar_counter .soon-label').forEach(function (label) {
      var key = { HRS: 'hours', MINS: 'minutes', SECS: 'seconds' }[label.textContent.trim()];
      if (key) label.textContent = copy[key];
    });
    document.querySelectorAll('#loox-floating-widget-btn').forEach(function (button) {
      var walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.trim() === 'Reviews') node.nodeValue = copy.reviews;
      }
      if (button.getAttribute('aria-label') === 'Reviews') button.setAttribute('aria-label', copy.reviews);
    });
  }
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; update(); });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  update();
})();
